export default __webpack_public_path__ + "static/blackcliff_pole-ca4017f873238984cfd88ac688244bf3.png";